/* Atelier — withdrawal-form.js : rétractation en ligne (art. L221-21 et D221-5 du Code de la consommation).
   Chargé uniquement par la section main-withdrawal. Amélioration progressive : sans JS, le formulaire natif s'envoie.
   À l'envoi : objet du message avec le numéro de commande, date et heure d'envoi (Europe/Paris + UTC), copie de la
   déclaration dans sessionStorage (onglet courant). Après la redirection, Liquid ne connaît plus les valeurs saisies :
   l'accusé de réception à l'écran est rempli depuis cette copie, uniquement avec textContent. */

(() => {
  if (customElements.get('withdrawal-form')) return;

  const read = (key) => {
    try {
      return JSON.parse(window.sessionStorage.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  };

  const write = (key, value) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) { /* stockage bloqué : l'envoi n'est pas affecté, l'accusé à l'écran reste générique */ }
  };

  const formatDate = (iso) => {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'fr', {
        timeZone: 'Europe/Paris',
        dateStyle: 'full',
        timeStyle: 'long'
      }).format(date);
    } catch (e) {
      return date.toISOString();
    }
  };

  class WithdrawalForm extends HTMLElement {
    connectedCallback() {
      this.key = this.dataset.storageKey || 'withdrawal-declaration';

      const receipt = this.querySelector('[data-withdrawal-receipt]');
      if (receipt) {
        this.showReceipt(receipt);
        return;
      }

      this.form = this.querySelector('form');
      if (!this.form) return;
      this.submitButton = this.form.querySelector('[type="submit"]');

      const errors = this.querySelector('[data-withdrawal-errors]');
      if (errors) {
        this.restoreDraft();
        errors.focus();
      }

      this.form.addEventListener('submit', () => this.onSubmit());
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.setBusy(false);
      });
    }

    fields() {
      return [...this.form.querySelectorAll('[data-field]')];
    }

    onSubmit() {
      const submittedAt = new Date().toISOString();
      const data = { submitted_at: submittedAt };
      this.fields().forEach((field) => {
        data[field.dataset.field] = field.value.trim();
      });

      const stamp = this.form.querySelector('[data-withdrawal-timestamp]');
      if (stamp) stamp.value = `${formatDate(submittedAt)} (${submittedAt})`;

      const subject = this.form.querySelector('[data-withdrawal-subject]');
      const order = (data.order || '').replace(/^(?:#|n°|no\.|no(?=[\s\d]))\s*/i, '');
      if (subject && order) subject.value = `${subject.dataset.subjectPrefix} ${order}`;

      write(this.key, data);
      // Différé : le navigateur a déjà constitué les données envoyées, le double envoi est évité.
      window.setTimeout(() => this.setBusy(true), 0);
    }

    setBusy(busy) {
      if (!this.submitButton) return;
      this.submitButton.disabled = busy;
      if (busy) this.submitButton.setAttribute('aria-busy', 'true');
      else this.submitButton.removeAttribute('aria-busy');
    }

    restoreDraft() {
      const data = read(this.key);
      if (!data) return;
      this.fields().forEach((field) => {
        const value = data[field.dataset.field];
        if (typeof value === 'string' && value) field.value = value;
      });
    }

    showReceipt(receipt) {
      const data = read(this.key);
      if (data && data.submitted_at) {
        receipt.querySelectorAll('[data-receipt-field]').forEach((cell) => {
          const name = cell.dataset.receiptField;
          const value = name === 'submitted_at' ? formatDate(data.submitted_at) : data[name];
          const row = cell.closest('[data-receipt-row]');
          if (value) cell.textContent = value;
          if (row) row.hidden = !value;
        });
        receipt.querySelector('[data-receipt-generic]')?.setAttribute('hidden', '');
        receipt.querySelector('[data-receipt-details]')?.removeAttribute('hidden');

        const actions = receipt.querySelector('[data-receipt-actions]');
        if (actions) {
          actions.hidden = false;
          actions.querySelector('[data-receipt-print]')?.addEventListener('click', () => window.print());
        }
      }
      receipt.focus();
    }
  }

  customElements.define('withdrawal-form', WithdrawalForm);
})();
